import {BaseWidget} from "../../BaseWidget";
import {TicketOverviewCL} from "../../generated/TicketOverviewCL";
import {MuNamedWidgets} from "mu-widget/lib/MuWidget";
import {TreeSelector, TreeSelectorItem} from "../../TreeSelector";

export class UiPqmLauncher extends BaseWidget
{
	public cl: TicketOverviewCL = new TicketOverviewCL();

	// @ts-ignore
	muNamedWidget: MuNamedWidgets<{
		pqmItems: TreeSelector
	}>;

	beforeIndex() {
		this.muRegisterEvent('start');
		this.container.classList.add('pqm-launcher');
		this.muAppendContent(`
			<div mu="pqmItems:TreeSelector" mu-params='{"inModal":false}'></div>
		`)
	}

	async afterIndex() {
		const tree = this.muNamedWidget.pqmItems;
		tree.afterItemRender = (item) => {
			if (!item.data) {
				item.ui.title.classList.add('strong');
			} else {
				item.ui.title.classList.add('icon-before-play');
				item.muVisible(false, 'bCollapse');
			}
		}
		tree.bindTree(
			await this.cl.getStartablePqmItems()
		);
	}

	pqmItems_change(ev: Event, id: string, item: TreeSelectorItem) {
		if (item.data) this.muDispatchEvent('start', item.data.id);
		else item.ui.bCollapse.click();
		this.muNamedWidget.pqmItems.setSelected('--', false);
	}

}